import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=0a7f2e82"
import script from "./TablePagination.vue?vue&type=script&lang=js"
export * from "./TablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports